import styled from "styled-components";

export const TippingHistoryRecordGameTipIdBox = styled.div`
    padding-left: 10px;
    
    @media ${({theme}) => theme.mediaQuery.sAndBelow} {  
      padding-left: 0;
    }
  
`